import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CContainer, CRow, CCol, CListGroup, CListGroupItem, CCard, CCardHeader, CCardBody, CSpinner } from '@coreui/react';
import api from '../../api/axiosInstance';

const ChapterTopicView = () => {
 const { section, title } = useParams(); // URL se Category/Title milega (e.g., /algebra)
  const navigate = useNavigate();

  const [chapters, setChapters] = useState([]);
  const [selectedChapterId, setSelectedChapterId] = useState(null);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChaptersAndTopics = async () => {
      setLoading(true);
      try {
        // Backend API call - Replace with your endpoint
        const res = await api.get(`/api/content/GetChapterWisePapers?section=${section}&category=${title}`, { skipAuthCheck: true });
        
        // Expected data structure: [{ id: 1, name: 'Logarithm', topics: [{ id: 101, name: 'Characteristics and Mantissa' }] }]
        const data = res.data || [];
        setChapters(data);

        // First chapter auto-select karein agar list empty na ho
        if (data.length > 0) {
          setSelectedChapterId(data[0].id);
          setTopics(data[0].topics || []);
        }
      } catch (err) {
        console.error('Error fetching chapters and topics:', err);
      } finally {
        setLoading(false);
      }
    };

    if (section && title) {
      fetchChaptersAndTopics();
    }
  }, [section, title]);

  // Chapter click hone par right side ke topics change karein
  const handleChapterClick = (chapter) => {
    setSelectedChapterId(chapter.id);
    setTopics(chapter.topics || []);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <CSpinner color="primary" />
        <p className="mt-2">Loading Chapters & Topics...</p>
      </div>
    );
  }

  return (
    <CContainer className="py-4">
      <h3 className="mb-4 text-capitalize">
        {title ? title.replace(/-/g, ' ') : 'Course Content'}
      </h3>

      <CRow className="g-4">
        {/* LEFT SIDE: CHAPTERS LIST */}
        <CCol md={4}>
          <CCard className="shadow-sm border-dark">
            <CCardHeader className="bg-primary text-white fw-bold">
              Chapters ({chapters.length})
            </CCardHeader>
            <CCardBody className="p-0">
              {chapters.length === 0 ? (
                <div className="p-3 text-muted text-center">No chapters found.</div>
              ) : (
                <CListGroup flush>
                  {chapters.map((ch) => (
                    <CListGroupItem
                      key={ch.id}
                      action
                      active={selectedChapterId === ch.id}
                      onClick={() => handleChapterClick(ch)}
                      style={{ cursor: 'pointer' }}
                      className="d-flex justify-content-between align-items-center fw-medium"
                    >
                      {ch.name}
                      <span className="badge bg-secondary rounded-pill">
                        {ch.topics?.length || 0}
                      </span>
                    </CListGroupItem>
                  ))}
                </CListGroup>
              )}
            </CCardBody>
          </CCard>
        </CCol>

        {/* RIGHT SIDE: TOPICS LIST */}
        <CCol md={8}>
          <CCard className="shadow-sm border-dark">
            <CCardHeader className="bg-light text-dark fw-bold">
              Topics List
            </CCardHeader>
            <CCardBody>
              {topics.length === 0 ? (
                <div className="text-muted p-3 text-center">
                  Select a chapter to view its topics.
                </div>
              ) : (
                <CListGroup variant="flush">
                  {topics.map((topic, index) => (
                    <CListGroupItem 
                      key={topic.id || index}
                      className="d-flex align-items-center gap-2 border-bottom py-3"
                    >
                      <span className="text-primary fw-bold">&gt;&gt;</span>
                      <span className="fw-semibold text-dark">{topic.name || topic}</span>
                    </CListGroupItem>
                  ))}
                </CListGroup>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default ChapterTopicView;